// extracted by mini-css-extract-plugin
export default {"group":"group__ada3a2db","horizontal":"horizontal__ada3a2db","vertical":"vertical__ada3a2db","item":"item__ada3a2db"};